<template functional>
    <button
        class="a-service-button service-button"
        type="button"
        @click="listeners.click(props.item)"
        :aria-label="`${ariaLabel} ${$options.store.getters.t(props.item, 'name')}`"
    >
        <span class="service-button__icon-container">
            <img
                v-if="props.item.files.icon"
                class="service-button__icon"
                :alt="$options.store.getters.t(props.item, 'name')"
                :src="props.item.files.icon"
            >
        </span>
        <span 
            class="service-button__title"
            v-if="props.isShowTitle"
        >
            {{ $options.store.getters.t(props.item, 'name') }}

        </span>
    </button>
</template>

<script>

import store from "@/store";

export default {
    name: "AServiceButton",
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        ariaLabel: {
            type: String,
            default: 'Service button'
        },
        isShowTitle: {
            type: Boolean,
            default: true
        }
    },
    store,
}
</script>

<style lang="scss">
@import "a-service-button";
</style>
